import { render, staticRenderFns } from "./ListCompleted.vue?vue&type=template&id=1d55865c&scoped=true"
import script from "./ListCompleted.vue?vue&type=script&lang=js"
export * from "./ListCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55865c",
  null
  
)

export default component.exports